import { render, staticRenderFns } from "./claimDetails.vue?vue&type=template&id=3f12af06"
import script from "./claimDetails.vue?vue&type=script&lang=js"
export * from "./claimDetails.vue?vue&type=script&lang=js"
import style0 from "./claimDetails.vue?vue&type=style&index=0&id=3f12af06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports